/** One delegated controller supports every current and future data-qr trigger. */
export function initQrActions() {
  const dialog=document.querySelector('[data-qr-dialog]');
  if(!dialog || typeof dialog.showModal!=='function') return ()=>{};
  const desktop=matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const title=dialog.querySelector('[data-qr-title]');
  const copy=dialog.querySelector('[data-qr-description]');
  const image=dialog.querySelector('[data-qr-image]');
  const link=dialog.querySelector('[data-qr-destination]');
  const error=dialog.querySelector('[data-qr-error]');
  const imageError=()=>{image.parentElement.hidden=true;error.hidden=false;};
  image.addEventListener('error',imageError);
  let trigger=null,previousOverflow='',animation=null,closing=false,disposed=false;
  const safe=url=>/^(https?:\/\/|mailto:|tel:|\/(?!\/)|#)/i.test(url||'');
  function restore() {
    animation?.cancel();animation=null;closing=false;
    document.documentElement.style.overflow=previousOverflow;
    trigger?.setAttribute('aria-expanded','false');
    const target=desktop.matches?trigger:trigger?.closest('.qr-action')?.querySelector('[data-qr-direct] a');
    if(target?.isConnected) target.focus({preventScroll:true});
    trigger=null;
  }
  function animate(opening) {
    animation?.cancel();
    if(motion.matches) return Promise.resolve();
    animation=dialog.animate([{transform:opening?'translateX(100%)':'translateX(0)'},{transform:opening?'translateX(0)':'translateX(100%)'}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
    return animation.finished.catch(()=>{});
  }
  async function close(immediate=false) {
    if(!dialog.open||closing) {if(immediate&&dialog.open){animation?.cancel();dialog.close();}return;}
    closing=true;
    if(!immediate) await animate(false);
    if(!disposed&&dialog.open) dialog.close();
  }
  function open(button) {
    if(!desktop.matches||dialog.open||!safe(button.dataset.qrUrl)) return;
    const data=button.dataset;
    if(!/^(https?:\/\/|\/(?!\/))/i.test(data.qrImage||'')) return;
    trigger=button;previousOverflow=document.documentElement.style.overflow;
    title.textContent=data.qrHeading||'Scan the QR Code';
    copy.textContent=data.qrCopy||'';copy.hidden=!data.qrCopy;
    dialog.toggleAttribute('aria-describedby',!!data.qrCopy);
    if(data.qrCopy)dialog.setAttribute('aria-describedby','qr-copy');
    image.parentElement.hidden=false;error.hidden=true;
    image.src=data.qrImage;image.alt=`QR code for ${data.qrLabel}`;
    link.href=data.qrUrl;link.textContent=data.qrLabel;
    link.target=data.qrTarget==='_blank'?'_blank':'_self';link.rel='noopener noreferrer';
    button.setAttribute('aria-expanded','true');
    dialog.showModal();document.documentElement.style.overflow='hidden';
    animate(true);
  }
  const click=event=>{
    const button=event.target.closest('[data-qr]');
    if(button) {event.preventDefault();open(button);}
    else if(event.target.closest('[data-qr-close]')||event.target===dialog) close();
    else if(event.target.closest('[data-qr-destination]')&&link.target!=='_blank') close(true);
  };
  const cancel=event=>{event.preventDefault();close();};
  const keyboard=event=>{
    if(event.key!=='Tab')return;
    const targets=[...dialog.querySelectorAll('button:not(:disabled),a[href]')].filter(el=>el.getClientRects().length);
    const first=targets[0],last=targets.at(-1);
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  };
  const resize=()=>{if(!desktop.matches)close(true);};
  const reduce=()=>{if(motion.matches){animation?.finish();}};
  document.addEventListener('click',click);dialog.addEventListener('cancel',cancel);dialog.addEventListener('close',restore);dialog.addEventListener('keydown',keyboard);
  desktop.addEventListener('change',resize);motion.addEventListener('change',reduce);
  document.documentElement.classList.add('qr-enhanced');
  return ()=>{
    disposed=true;animation?.cancel();
    if(dialog.open){dialog.close();restore();}
    document.removeEventListener('click',click);dialog.removeEventListener('cancel',cancel);dialog.removeEventListener('close',restore);dialog.removeEventListener('keydown',keyboard);
    desktop.removeEventListener('change',resize);motion.removeEventListener('change',reduce);
    image.removeEventListener('error',imageError);
    document.documentElement.classList.remove('qr-enhanced');
  };
}
